/* ── MIGRATION GUARD ──────────────────────────────────────────
   quick view — would conflict with the theme’s own quick view while that app is live.
   Runs ONLY in preview (?br_preview=1) until you switch it on for
   real by adding 'quickview' to window.BR_LIVE. ------------------- */
(function(){
  var live = (window.BR_LIVE || []).indexOf('quickview') > -1;
  var preview = document.documentElement.classList.contains('br-preview');
  if (!live && !preview) return;   // dormant: the existing app keeps working untouched
/* ============================================================
   Quick View + Swatches — premium browse-to-cart.
   Injects a "Quick add" button onto product cards, opens a modal
   with color swatches + variant selection + add-to-cart (AJAX).
   Reuses window.BRCart (cro-cart.js) to sync the drawer.
   ============================================================ */
(function () {
  var COLOR_OPT = /colou?r|shade|finish/i;
  var NAMED = { black:'#111', white:'#fff', ivory:'#faf6f1', cream:'#f3ebdd', beige:'#e8dcc8', gold:'#c6a15b', silver:'#c9cdd2', rose:'#d9a7a0', blush:'#e8cfc7', pink:'#e6a7c1', red:'#c0392b', green:'#5b8a72', sage:'#aeb89e', blue:'#5b7fa6', navy:'#2e3a59', purple:'#7d6b9e', brown:'#8a6d3b', espresso:'#4a3730', grey:'#9aa0a6', gray:'#9aa0a6', clear:'#e8ecf0', turquoise:'#4fb0a5', opal:'#dfeaf0', mocha:'#b98e7a', champagne:'#e6d3a3' };
  function swatchColor(name) { var k = (name || '').toLowerCase(); for (var key in NAMED) { if (k.indexOf(key) > -1) return NAMED[key]; } return null; }

  var modal;
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'qv'; modal.id = 'qv'; modal.hidden = true;
    modal.innerHTML = '<div class="qv__overlay" data-qv-close></div><div class="qv__card" role="dialog" aria-modal="true"><button class="qv__x" data-qv-close aria-label="Close">&times;</button><div class="qv__body"></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-qv-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    return modal;
  }
  function open() { ensureModal().hidden = false; document.documentElement.style.overflow = 'hidden'; }
  function close() { if (modal) modal.hidden = true; document.documentElement.style.overflow = ''; }

  var cache = {};
  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) { cache[handle] = p; return p; });
  }

  function money(c) { return '$' + (c / 100).toFixed(2); }

  function build(p) {
    var body = modal.querySelector('.qv__body');
    var selected = Object.assign({}, p.options.reduce(function (a, o, i) { var v = p.variants.find(function (x) { return x.available; }) || p.variants[0]; a[i] = v.options[i]; return a; }, {}));

    function currentVariant() {
      return p.variants.find(function (v) { return p.options.every(function (o, i) { return v.options[i] === selected[i]; }); });
    }
    function imgFor(optIndex, value) {
      var v = p.variants.find(function (x) { return x.options[optIndex] === value && x.featured_image; });
      return v && v.featured_image ? v.featured_image.src : null;
    }
    function render() {
      var v = currentVariant() || p.variants[0];
      var img = (v && v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
      var optionsHtml = p.options.map(function (o, i) {
        var name = (typeof o === 'string') ? o : (o.name || '');
        var isColor = COLOR_OPT.test(name);
        var vals = dedupe(p.variants.map(function (x) { return x.options[i]; }));
        var chips = vals.map(function (val) {
          var on = selected[i] === val ? ' is-on' : '';
          var avail = p.variants.some(function (x) { return x.options[i] === val && x.available; });
          var so = avail ? '' : ' qv__chip--out';
          if (isColor) {
            var sw = imgFor(i, val); var col = swatchColor(val);
            var style = sw ? 'background-image:url(' + sw + '&width=80)' : (col ? 'background:' + col : '');
            return '<button class="qv__sw' + on + so + '" data-opt="' + i + '" data-val="' + esc(val) + '" title="' + esc(val) + '" style="' + style + '"></button>';
          }
          return '<button class="qv__chip' + on + so + '" data-opt="' + i + '" data-val="' + esc(val) + '">' + esc(val) + '</button>';
        }).join('');
        return '<div class="qv__opt"><span class="qv__opt-name">' + esc(name) + '</span><div class="qv__chips">' + chips + '</div></div>';
      }).join('');

      var avail = v && v.available;
      body.innerHTML =
        '<div class="qv__media">' + (img ? '<img src="' + img + '&width=800" alt="">' : '') + '</div>' +
        '<div class="qv__info"><a class="qv__title" href="/products/' + p.handle + '">' + esc(p.title) + '</a>' +
        '<div class="qv__price"><b>' + money(v ? v.price : p.price) + '</b>' + (v && v.compare_at_price > v.price ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '</div>' +
        optionsHtml +
        '<button class="qv__add button button--primary" ' + (avail ? '' : 'disabled') + ' data-qv-add data-id="' + (v ? v.id : '') + '">' + (avail ? 'Add to bag' : 'Sold out') + '</button>' +
        '<a class="qv__full" href="/products/' + p.handle + '">View full details →</a></div>';
    }
    modal.querySelector('.qv__body').onclick = function (e) {
      var chip = e.target.closest('[data-opt]');
      if (chip) { selected[+chip.dataset.opt] = chip.dataset.val; render(); return; }
      var add = e.target.closest('[data-qv-add]');
      if (add && add.dataset.id) {
        add.disabled = true; add.textContent = 'Adding…';
        var done = function () { close(); if (window.BRCart) window.BRCart.open(); };
        if (window.BRCart) window.BRCart.add(add.dataset.id, 1).then(done).catch(function () { add.textContent = 'Try again'; add.disabled = false; });
        else fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: Number(add.dataset.id), quantity: 1 }) }).then(function () { window.location = '/cart'; });
      }
    };
    render();
  }
  function dedupe(a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); }

  // Inject Quick-add buttons onto cards
  function inject() {
    document.querySelectorAll('.card-wrapper:not([data-qv-done]), .best-sellers__card:not([data-qv-done])').forEach(function (card) {
      var link = card.querySelector('a[href*="/products/"]'); if (!link) return;
      card.setAttribute('data-qv-done', '1');
      var handle = (link.getAttribute('href').split('/products/')[1] || '').split('?')[0].split('/')[0];
      if (!handle) return;
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'qv__trigger'; btn.textContent = 'Quick add';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        open(); modal.querySelector('.qv__body').innerHTML = '<div class="qv__loading">Loading…</div>';
        load(handle).then(build).catch(function () { close(); window.location = link.href; });
      });
      var media = card.querySelector('.card__media, .best-sellers__media, .media') || card;
      media.style.position = media.style.position || 'relative';
      media.appendChild(btn);
    });
  }
  if (document.readyState !== 'loading') inject(); else document.addEventListener('DOMContentLoaded', inject);
  // re-inject after AJAX section renders
  new MutationObserver(function () { inject(); }).observe(document.body, { childList: true, subtree: true });
})();

})();
